import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

import { ScrollLockService } from '../../services/scroll-lock.service';

@Component({
  selector: 'app-backdrop',
  imports: [],
  templateUrl: './backdrop.component.html',
  styleUrls: ['./backdrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackdropComponent implements OnDestroy {
  private scrollLockService = inject(ScrollLockService);

  @HostBinding('class.shown')
  isShown = false;

  @Input()
  blockScroll = true;

  @Input()
  overflowStyleOverwrite?: string;

  @Input({ transform: booleanAttribute })
  set isVisible(v: boolean) {
    this.isShown = v;
    this.updateScroll();
  }

  @Input()
  closeOnClick = true;

  @Output()
  closed = new EventEmitter<void>();

  ngOnDestroy(): void {
    this.scrollLockService.unlock();
  }

  toggle(): void {
    this.isShown = !this.isShown;
    this.updateScroll();
  }

  updateScroll(): void {
    if (!this.isShown) {
      this.closed.emit();
    }

    if (!this.blockScroll) {
      return;
    }

    if (this.isShown) {
      this.scrollLockService.lock(this.overflowStyleOverwrite);
    } else {
      this.scrollLockService.unlock();
    }
  }

  onBackdropClick(): void {
    if (this.closeOnClick) {
      this.toggle();
    }
  }
}
